export const RequestLabels = {
  recut: "Recut",
  rescan: "Rescan",
  reembed: "Reembed",
  repeat: "Repeat Order",
  deepep: "Order Deeper Epidermis",
};
